function disableDragEvent(event) {
  event.preventDefault();
}

export default disableDragEvent;